import { createMetaRoute } from '@funtech-int/rival';

import { RouteMeta } from '@/shared/lib/navigation';

export const playerRoute = createMetaRoute<
    RouteMeta,
    { contentId: string },
    { startTime?: number }
>({
    key: (params) => params.contentId,
});
